var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"label":"Australian Business Number (ABN)","value":_vm.value,"rules":_vm.rules,"loading":_vm.loading},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }